import { useState, useEffect } from 'react'
import { legalService } from '@services/api/legal'

function PrivacyPage() {
  const [page, setPage] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    legalService.getPublic('privacy')
      .then(res => { if (res.success) setPage(res.data) })
      .catch(() => {})
      .finally(() => setLoading(false))
  }, [])

  // Nettoie le HTML collé (styles inline, espaces insécables, balises vides)
  const cleanContent = (html) => {
    if (!html) return ''
    return html
      .replace(/\s*style="[^"]*"/gi, '')
      .replace(/&nbsp;/gi, ' ')
      .replace(/<(h[1-6]|p)>\s*(<br\s*\/?>)?\s*<\/\1>/gi, '')
  }

  const title = page?.title || 'Politique de Confidentialité'

  return (
    <div className="min-h-screen bg-[#fefcf8]">
      <div className="w-full md:w-[90%] lg:w-[80%] mx-auto px-4 py-8">
        {/* Header */}
        <div className="bg-gradient-to-r from-[#001F3F] to-[#003366] rounded-2xl p-8 md:p-12 mb-8 text-white">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">{title}</h1>
          {page?.updated_at && (
            <p className="text-lg">
              Dernière mise à jour : {new Date(page.updated_at).toLocaleDateString('fr-FR')}
            </p>
          )}
        </div>

        {/* Contenu dynamique */}
        <div className="bg-white rounded-xl shadow-sm p-6 md:p-8">
          {loading ? (
            <div className="flex items-center justify-center py-20">
              <div className="w-8 h-8 border-2 border-[#D4AF37] border-t-transparent rounded-full animate-spin" />
            </div>
          ) : page?.content ? (
            <div
              className="
                max-w-none text-gray-700 leading-relaxed
                [&_h1]:text-2xl [&_h1]:md:text-3xl [&_h1]:font-bold [&_h1]:text-[#001F3F] [&_h1]:mt-8 [&_h1]:mb-4 [&_h1]:first:mt-0
                [&_h2]:text-xl [&_h2]:md:text-2xl [&_h2]:font-bold [&_h2]:text-[#001F3F] [&_h2]:mt-8 [&_h2]:mb-4 [&_h2]:pb-2 [&_h2]:border-b [&_h2]:border-gray-100 [&_h2]:first:mt-0
                [&_h3]:text-base [&_h3]:font-medium [&_h3]:text-gray-800 [&_h3]:mt-3 [&_h3]:mb-2 [&_h3]:leading-relaxed
                [&_p]:mb-4 [&_p]:text-gray-700 [&_p]:leading-relaxed
                [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:mb-4 [&_ul]:space-y-1.5
                [&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:mb-4 [&_ol]:space-y-1.5
                [&_li]:text-gray-700 [&_li]:leading-relaxed [&_li]:pl-1 [&_li]:marker:text-[#D4AF37]
                [&_a]:text-[#D4AF37] [&_a]:font-medium [&_a]:underline [&_a]:underline-offset-2
                [&_strong]:text-[#001F3F] [&_strong]:font-semibold
                [&_blockquote]:border-l-4 [&_blockquote]:border-[#D4AF37] [&_blockquote]:pl-4 [&_blockquote]:italic [&_blockquote]:text-gray-600 [&_blockquote]:my-4
                [&_img]:rounded-lg [&_img]:my-4 [&_img]:max-w-full
                [&_.ql-align-center]:text-center [&_.ql-align-right]:text-right [&_.ql-align-justify]:text-justify
                [&_.ql-indent-1]:pl-8 [&_.ql-indent-2]:pl-16 [&_.ql-indent-3]:pl-24
              "
              dangerouslySetInnerHTML={{ __html: cleanContent(page.content) }}
            />
          ) : (
            <div className="text-center py-16 text-gray-400">
              <svg className="w-12 h-12 mx-auto mb-3 text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <p className="text-sm font-medium text-gray-500">Le contenu sera bientôt disponible.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default PrivacyPage
